import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule as MatDialogModule } from '@angular/material/dialog';

import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { DragScrollModule } from 'ngx-drag-scroll';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule as MatTabsModule } from '@angular/material/tabs';
// modules (angular)
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
// modules
import { SharedModule } from '@shared/shared.module';
// components
import { AccountMenuComponent } from './components/account-menu/account-menu.component';
import { DepartmentsComponent } from './components/departments/departments.component';
import { DropcartComponent } from './components/dropcart/dropcart.component';
import { DropdownCategoriesComponent } from './components/dropdown-categories/dropdown-categories.component';
import { IndicatorComponent } from './components/indicator/indicator.component';
import { LinksComponent } from './components/links/links.component';
import { MegamenuComponent } from './components/megamenu/megamenu.component';
import { MenuComponent } from './components/menu/menu.component';
import { NavComponent } from './components/nav/nav.component';
import { HeaderComponent } from './header.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
 
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CityDialogComponent } from './components/city-dialog/city-dialog.component';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
    imports: [
    // modules (angular)
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    // modules
    SharedModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    CarouselModule,
    DragScrollModule,
    MatTabsModule,
    MatCheckboxModule,
    MatFormFieldModule,
    
    NgxMatSelectSearchModule,
    MatDialogModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    // components
    AccountMenuComponent,
    DepartmentsComponent,
    DropcartComponent,
    HeaderComponent,
    IndicatorComponent,
    LinksComponent,
    MegamenuComponent,
    MenuComponent,
    NavComponent,
    DropdownCategoriesComponent,
    CityDialogComponent
],
    exports: [
        // components
        HeaderComponent,
        DropcartComponent,
        IndicatorComponent,
    ]
})
export class HeaderModule { }
